/**
 * 广告数据分析
 */
import axios from "../../utils/axios1";

// 测试
export function telnet_case(data) {
    return axios({
        url: "/telnet_case",
        method: "get",
        params: data
    });
}

//添加
export function file_upload(consumerName, data) {
    return axios({
        url: "/apis/ad_data_analysis/file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//列表
export function show_list(data) {
    return axios({
        url: "/apis/ad_data_analysis/show_list",
        method: "post",
        data: data
    });
}
//列表
export function show_list_new(data) {
    return axios({
        url: "/apis/ad_data_analysis/show_list_new",
        method: "post",
        data: data
    });
}
//到处数据
export function search_word_file_export_by_date(data) {
    return axios({
        url: "/apis/ad_data_analysis/search_word_file_export_by_date",
        method: "post",
        data: data
    });
}
//按日期删除搜索词数据
export function search_word_delete_by_date(data) {
    return axios({
        url: "/apis/ad_data_analysis/search_word_delete_by_date",
        method: "post",
        data: data
    });
}

//手动录入词根
export function add_manual_root(data) {
    return axios({
        url: "/apis/ad_data_analysis/add_manual_root",
        method: "post",
        data: data
    });
}

//获取手动录入词根
export function get_manual_root_list(data) {
    return axios({
        url: "/apis/ad_data_analysis/get_manual_root_list",
        method: "post",
        data: data
    });
}

//获取广告分组名称
export function get_ad_min_name_list(data) {
    return axios({
        url: "/apis/ad_data_analysis/get_ad_min_name_list",
        method: "post",
        data: data
    });
}

//更新广告分组名称数据
export function update_ad_min_name_list(data) {
    return axios({
        url: "/apis/ad_data_analysis/update_ad_min_name_list",
        method: "post",
        data: data
    });
}

//更新广告分组名称数据
export function update_ad_min_name_by_dict(data) {
    return axios({
        url: "/apis/ad_data_analysis/update_ad_min_name_by_dict",
        method: "post",
        data: data
    });
}

//上传防内部竞价文件
export function prevent_internal_competition_add(obj, data) {
    return axios({
        url: "/apis/open_ad_group/prevent_internal_competition_add",
        method: "post",
        params: obj,
        data: data
    });
}

//防内部竞价记录展示
export function prevent_internal_competition_show(data) {
    return axios({
        url: "/apis/open_ad_group/prevent_internal_competition_show",
        method: "post",
        data: data
    });
}

//防内部竞价记录删除
export function prevent_internal_competition_delete(data) {
    return axios({
        url: "/apis/open_ad_group/prevent_internal_competition_delete",
        method: "post",
        data: data
    });
}

//广告搜索词记录删除
export function search_word_delete(data) {
    return axios({
        url: "/apis/ad_data_analysis/search_word_delete",
        method: "post",
        data: data
    });
}
